import type { HTMLAttributes, ReactElement } from 'react'

type Props = HTMLAttributes<HTMLDivElement> & {
  readonly text?: string
}

export function Copyright({
  text = '',
  className = '',
  style
}: Props): ReactElement {
  const currentYear = new Date().getFullYear()
  return (
    <div className={className} style={style}>
      <span className="text-sm">
        © {currentYear} {text}
      </span>
    </div>
  )
}
